export enum EMarkType {
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
  Link = 'link',
  Strike = 'strike',
}
